import SplitMenuButton from './SplitMenuButton'
export * from './SplitMenuButton'
export default SplitMenuButton
